module.exports = __webpack_public_path__ + "static/media/link.e312b2ad.svg";